import React from "react";
import "./index.css";
import App from "./App";
import Modal from "react-modal";
import { createRoot } from "react-dom/client";

const rootElement = document.getElementById("root");

const root = createRoot(rootElement);
Modal.setAppElement(rootElement);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
